/**
 * Central export for all Pinia stores and mock data
 */

// Pinia stores
import { useCustomerStore } from './customerStore'
import { useCarStore } from './carStore'
import { useCaseStore } from './caseStore'
import { useInsuranceEventStore } from './insuranceEventStore'
import { useTicketStore } from './ticketStore'
import { useCalendarEventStore } from './calendarEventStore'
import { useLongTermCaseStore } from './longTermCaseStore'
import { useComplaintStore } from './complaintStore'
import { useEurodriveAuthStore } from "./eurodriveAuthStore";

export { useCustomerStore } from './customerStore'
export { useCarStore } from './carStore'
export { useCaseStore } from './caseStore'
export { submitCase, submitFromForm, returnCar } from './caseWorkflows'
export { useInsuranceEventStore } from './insuranceEventStore'
export { useTicketStore } from './ticketStore'
export type { TicketSearchResult } from './ticketStore'
export { usePreferencesStore } from './preferencesStore'
export type { UIScale, UIDensity } from './preferencesStore'
export { useCalendarEventStore } from './calendarEventStore'
export { useLongTermCaseStore } from './longTermCaseStore'
export { useComplaintStore } from './complaintStore'
export { useCompanyRegistryStore } from './companyRegistryStore'

export const resetUserDataStores = () => {
  useCustomerStore().$reset()
  useCarStore().$reset()
  useCaseStore().$reset()
  useInsuranceEventStore().$reset()
  useTicketStore().$reset()
  useCalendarEventStore().$reset()
  useLongTermCaseStore().$reset()
  useComplaintStore().$reset()
  useEurodriveAuthStore().$reset()
}

// Re-export insurance event types
export type {
  InsuranceEvent,
  InsuranceEventStatus,
  InsuranceEventCustomData,
  CreateInsuranceEventRequest,
  RentalCarData,
  ResponsiblePersonData,
  CompanyData
} from './insuranceEventStore'
export {
  getInsuranceEventCustomerName,
  getInsuranceEventCarName
} from './insuranceEventStore'

// Re-export calendar event types
export type {
  CalendarEvent,
  CalendarEventForm,
  CalendarEventStatus,
  CalendarEventType,
  FullCalendarEvent
} from './calendarEventStore'
export {
  EVENT_TYPE_CONFIG,
  createEmptyCalendarEventForm
} from './calendarEventStore'

// Re-export complaint types
export type {
  Complaint,
  ComplaintStatus,
  ComplaintCause,
  CreateComplaintRequest
} from './complaintStore'
export {
  complaintStatusLabels,
  complaintStatusColors,
  complaintCauseLabels,
  getOpenComplaint,
  hasOpenComplaint,
  getComplaintLabel
} from './complaintStore'

// Re-export types and utilities from API types
export * from '~/api/types/options'
export * from '~/api/types/car'
export * from '~/api/types/rentalCase'
export * from '~/api/types/customer'
export * from '~/api/types/longTermCase'
export * from '~/utils/processStatus'
